import { createSlice } from '@reduxjs/toolkit';
import appTypes from '../app/types';
const initialState = {
    isLoaded: false,
    isValid: false,
    invalidAnswers: 0,
    shouldCheckDismissLogicOrValid: null,
    shouldShowPopup: null,
    alreadyAnswered: null,
    currentContactId: null,
    userAnswers: [],
    numOfAnswers: 0,
};
const slice = createSlice({
    name: 'UGC',
    initialState,
    extraReducers(builder) {
        builder.addCase(appTypes.RESET, () => initialState);
    },
    reducers: {
        set(state, { payload }) {
            return Object.assign(Object.assign({}, state), payload);
        },
        setIsLoaded(state, { payload }) {
            state.isLoaded = payload;
        },
        setSettings(state, { payload }) {
            state.invalidAnswers = payload.invalidAnswers;
            state.isValid = payload.isValid;
        },
        setUserAnswers(state, { payload }) {
            state.userAnswers = payload.userAnswers;
            state.numOfAnswers = payload.numOfAnswers;
        },
        setShouldShowPopup(state, { payload }) {
            state.shouldShowPopup = payload;
        },
        setShouldCheckDismissLogicOrValid(state, { payload }) {
            state.shouldCheckDismissLogicOrValid = payload;
        },
        /**
         * Raises `alreadyAnswered` when the contact is in `userAnswers`. Sticky by design — it mirrors
         * the MST action, which only ever set the flag to `true`.
         */
        setAlreadyAnswered(state, { payload }) {
            if (payload && state.userAnswers.includes(payload)) {
                state.alreadyAnswered = true;
            }
        },
        setCurrentContactId(state, { payload }) {
            state.currentContactId = payload || null;
        },
    },
});
export const { reducer, actions } = slice;
export default reducer;
